<template>
  <div
    v-if="
      !(hideDeregisteredWidget || hideDeregisteredWidgetDueToNoSurveyResults)
    "
    class="puls-skeleton-loader card"
  >
    <div v-if="skeletonInfo">
      <div v-if="skeletonInfo.header" class="card-header position-relative">
        <h4 class="card-title w-100">
          <Skeleton
            width="100%"
            :height="height(skeletonInfo.header.height)"
            :childClass="disableAnimation ? 'paused' : 'running'"
          />
        </h4>
        <div
          v-if="deregisteredWidget"
          class="skeleton-text-overlay skeleton-text-overlay--header"
        ></div>
      </div>
      <div
        v-if="skeletonInfo.body && skeletonInfo.body.length"
        class="card-body position-relative"
      >
        <div
          v-for="(row, rowIndex) in skeletonInfo.body"
          :key="rowIndex"
          class="d-flex gap-5 mb-5"
        >
          <div
            v-for="(col, colIndex) in row.cols"
            :key="colIndex"
            class="flex-grow-1"
          >
            <Skeleton
              :enableAnimation="false"
              :height="col.type !== 'circle' ? height(col.height) : ''"
              :class="col.type === 'circle' ? 'circle' : ''"
              :childClass="disableAnimation ? 'paused' : 'running'"
            />
          </div>
        </div>
        <div
          v-if="deregisteredWidget"
          class="skeleton-text-overlay skeleton-text-overlay--body"
        >
          <p class="fs-4">
            {{ deregistrationMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorTypes } from '@/constants/error-types'

export default {
  name: 'PulsSkeletonLoader',
  props: {
    skeletonInfo: {
      type: Object,
      default: () => {}
    },
    deregisteredWidget: {
      type: Object,
      default: () => {}
    },
    hasResults: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disableAnimation() {
      return this.deregisteredWidget !== undefined
    },
    hideDeregisteredWidget() {
      return this.deregisteredWidget?.info?.hideWidget
    },
    hideDeregisteredWidgetDueToNoSurveyResults() {
      return (
        this.deregisteredWidget?.info?.hideWidgetWhenNoSurveyResults &&
        !this.hasResults
      )
    },
    deregistrationMessage() {
      if (
        this.deregisteredWidget?.info?.reason === errorTypes.NOT_ENOUGH_DATA
      ) {
        return this.$t('widgetAlert.notEnoughData')
      }
      return ''
    }
  },
  methods: {
    height(height) {
      return `${height * 10}px`
    }
  }
}
</script>

<style lang="scss">
.skeleton-loading {
  background-color: var(--kt-gray-300) !important;
  animation: placeholder-glow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.skeleton-container {
  width: 100%;
  &.circle {
    .skeleton-loading {
      border-radius: 50%;
      aspect-ratio: 1 / 1;
    }
  }
  .skeleton-loading {
    &.paused {
      animation: none;
    }
  }
}
.skeleton-text-overlay {
  padding: 2rem 2.25rem;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: color-mix(
    in srgb,
    var(--kt-text-gray-100) 70%,
    transparent 30%
  );
  backdrop-filter: blur(2px);
  &--header {
    border-top-left-radius: var(--bs-card-border-radius);
    border-top-right-radius: var(--bs-card-border-radius);
  }
  &--body {
    border-bottom-left-radius: var(--bs-card-border-radius);
    border-bottom-right-radius: var(--bs-card-border-radius);
  }
}
</style>
